"use client";

import { useTheme } from "@up/data";
import { getSocialLinks, UPLink } from "@up/ui";

// The links are `inline-block` in a centered text block, so a block-level flex
// group keeps the social icons on their own centered row above them.
const SOCIAL_GROUP_CLASS = "flex justify-center gap-4 mb-4";
const SOCIAL_CLASS =
  "flex items-center justify-center w-10 h-10 text-white border border-solid border-white rounded-full transition-transform hover:scale-110";

export default function Footer() {
  const theme = useTheme();
  const socialLinks = getSocialLinks(theme);

  return (
    <footer
      id="footer"
      className="theme-blue-dark text-center text-base pt-12 pb-6 relative z-40 lg:py-6 lg:px-12 lg:flex lg:items-center"
    >
      <img
        className="mb-16 mx-auto lg:mb-0"
        src="/logo-footer.png"
        alt="Georgetown University"
        width="147"
        height="31"
      />

      <div className="px-3 grow">
        {socialLinks.length > 0 ? (
          <div className={SOCIAL_GROUP_CLASS}>
            {socialLinks.map(({ Icon, href, label }) => (
              <UPLink
                key={label}
                className={SOCIAL_CLASS}
                href={href}
                target="_blank"
                data-link="external"
              >
                <Icon />
                <span className="sr-only">{label}</span>
              </UPLink>
            ))}
          </div>
        ) : null}
        <UPLink
          className="underline p-1 inline-block m-px"
          href="/sitemap"
          prefetch={false}
        >
          Sitemap
        </UPLink>{" "}
        &nbsp;
        <UPLink
          className="underline p-1 inline-block m-px"
          href="/privacy-policy"
          prefetch={false}
        >
          Privacy Policy
        </UPLink>{" "}
        &nbsp;
        <UPLink
          className="underline p-1 inline-block m-px"
          href="/terms-of-use"
          prefetch={false}
        >
          Terms of Use
        </UPLink>{" "}
        &nbsp;
        <a
          className="underline p-1 inline-block m-px"
          href={`mailto:${theme.supportEmail}`}
        >
          Contact Info
        </a>{" "}
        &nbsp;
        <a
          className="underline m-px p-1 block sm:inline-block"
          href="https://docs.google.com/forms/d/e/1FAIpQLSd2cgxOVvjV8PRxnqc3NvuG7AMp2RNb4WZAP_0AQ_BBLn6W-A/viewform"
          rel="noreferrer"
          target="_blank"
        >
          Do Not Sell or Share My Data
        </a>{" "}
        &nbsp;
        <UPLink
          className="underline p-1 inline-block m-px"
          href="/about-us"
          prefetch={false}
        >
          About Us
        </UPLink>
        <div className="font-serif pt-6 lg:pt-3">
          &copy; {new Date().getFullYear()} Georgetown University
        </div>
      </div>
    </footer>
  );
}
